import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Authenticate } from '../models/auth/authenticate';
import { IAuthenticate } from '../models/auth/interfaces/authenticate.interface';
import { ILogin } from '../models/auth/interfaces/login.interface';
import { Token } from '../models/auth/token';
import { Rights } from '../models/enums/rights';
import { DefaultHttpService } from './default-http.service';
import { MemoryService } from './memory.service';
import { ParamsService } from './params.service';

@Injectable({
    providedIn: 'root',
})
export class AuthService extends DefaultHttpService {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService,
        private paramsService: ParamsService
    ) {
        super(memoryService);
    }

    /**
     * Authentification de l'utilisateur
     */
    public logon(login: ILogin): Observable<Authenticate> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.post<IAuthenticate>(this.baseUrl + `/api/auth/logon`, login, httpOptions).pipe(
            map((x) => {
                let connectedUser = Authenticate.from(x);

                if (connectedUser.rights && connectedUser.rights.length > 0 && connectedUser.rights.some((x) => x == Rights.OrganizationRead)) {
                    this.memoryService.setConnectedUser(connectedUser);
                    return connectedUser;
                } else {
                    return null;
                }
            })
        );
    }

    /**
     * Deconnexion de l'utilisateur
     */
    public logoff(accessToken: string): Observable<any> {
        return this.http.delete(this.baseUrl + `/api/auth/logoff`).pipe(
            map((x) => {
                this.memoryService.setConnectedUser(null);
                this.memoryService.selectOrganization(null);
                return x;
            })
        );
    }

    // Deconnexion sauvage de l'utilisateur
    public wildLogoff(token: string): boolean {
        let data = { token: token };
        //const dataHistoryBlob = new Blob([JSON.stringify(data)], { type: 'application/json' });
        return navigator.sendBeacon(this.baseUrl + '/api/auth/logoff', JSON.stringify(data));
    }

    /**
     * Vérifit la validité du token.
     */
    public checkToken(): Observable<Token> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.get<Token>(this.baseUrl + `/api/auth/token`, httpOptions).pipe(
            map((x) => {
                let token = new Token();
                token.accessToken = x.accessToken;
                token.expireOn = new Date(x.expireOn);
                return token;
            })
        );
    }
    /**
     * Garde le token en vie.
     */
    public keepAliveToken(): Observable<boolean> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.patch<Token>(this.baseUrl + `/api/auth/token`, httpOptions).pipe(
            map((x) => {
                this.memoryService.updateUserToken(x);
                return true;
            })
        );
    }

    /**
     * Recupération de l'utilisateur par rapport au token
     */
    public getCurrentUser(accessToken: string): Observable<Authenticate> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.get<IAuthenticate>(this.baseUrl + `/api/auth/token/${accessToken}`, httpOptions).pipe(
            map((x) => {
                let userConnected = Authenticate.from(x);
                this.memoryService.setConnectedUser(userConnected);
                return userConnected;
            })
        );
    }
}
